module.exports = __webpack_public_path__ + "img/shang2.88988b49.png";